const exhibitionTypeOptions = [
  { label: "Solo", value: "Solo" },
  { label: "Group", value: "Group" },
  { label: "Artfair", value: "Artfair" },
  { label: "Viewing Room", value: "Viewing Room" },
  { label: "External", value: "External" },
  { label: "Cancelled", value: "Cancelled" },
];

export default exhibitionTypeOptions;
